const yup = require("yup");

const applicantloginrule = yup.object({
  emailaddress: yup.string().email("Invalid email address given").required("Valid email address is required"),
  password: yup
    .string()
    .min(8, "Minimum of 8 characters expected")
    .max(32, "Maximum of 32 characters expected")
    .required("Password is a required fields"),
});

const createapplicantrules = yup.object({
  firstname: yup.string().required("First name is a required field"),
  lastname: yup.string().required("Last name is a required field"),
  emailaddress: yup.string().email("Invalid email address").required("Valid email address is required"),
  jamb: yup.string().required("JAMB Admission number is a required field"),
  phonenumber: yup
    .string()
    .min(13, "Format not followed (23480xxxxxxxx)")
    .max(13, "Format not followed (23480xxxxxxxx)")
    .required("Phone number is a required field"),
  password: yup
    .string()
    .min(8, "Minimum of 8 characters expected")
    .max(32, "Maximum of 32 characters expected")
    .required("Password is a required field"),
  confirmpassword: yup.string().oneOf([yup.ref("password"), null], "Passwords must match"),
});

const update = yup.object({
  firstname: yup.string().required("First name is a required field"),
  lastname: yup.string().required("Last name is a required field"),
  emailaddress: yup.string().email("Invalid email address").required("Valid email address is required"),
  jamb: yup.string().required("JAMB Admission number is a required field"),
  phonenumber: yup
    .string()
    .min(13, "Format not followed (23480xxxxxxxx)")
    .max(13, "Format not followed (23480xxxxxxxx)")
    .required("Phone number is a required field"),
});

const forgetpasswordrules = yup.object({
  emailaddress: yup.string().email("Invalid email address").required("Valid email address is required"),
});

const createapplicantbiorules = yup.object({
  firstname: yup.string().min(1, "First name is a required field").required("First name is a required field"),
  lastname: yup.string().min(1, "Last name is a required field").required("Last name is a required field"),
  dateofbirth: yup.date().required("Date of birth is a required field"),
  gender: yup.string().required("Gender is a required field"),
  religion: yup.string().required("Religion is a required field"),
  qualification: yup.string().required("Qualification is a required field"),
  maritalstatus: yup.string().required("Marital status is a required field"),
  emailaddress: yup.string().email("Invalid email address").required("Email address is a required field"),
  phonenumber: yup
    .string()
    .min(13, "Format not followed (23480xxxxxxxx)")
    .max(13, "Format not followed (23480xxxxxxxx)")
    .required("Phone number is a required field"),
  homeaddress: yup.string().required("Contact address is a required field"),
  stateoforigin: yup.string().required("State of origin is a required field"),
  stateofresidence: yup.string().required("State of residence is a required field"),
  lgaoforigin: yup.string().required("LGA of origin is a required field"),
  lgaofresidence: yup.string().required("LGA of residence is a required field"),
});

module.exports = {
  applicantloginrule,
  createapplicantrules,
  forgetpasswordrules,
  update,
  createapplicantbiorules,
};
